module.exports = __webpack_public_path__ + "img/Logo Colored-3@2x.a42d8bdd.png";